<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<col style="width:550px;" />
						<col style="width:130px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Tag No</th>
							<td>
								<input type="text" v-model.trim="call_tag.call_tag_dn" class="tbl_int ssm2_int" readonly disabled />
								<span v-if="call_tag.del_yn == 'Y'" style="color:blue;">Void</span>
							</td>
							<th>Option</th>
							<td>
								<label class="mgr_10"><input type="radio" value="MAIL" v-model="call_tag.contact_option" /> MAIL</label>
								<label class="mgr_10"><input type="radio" value="EMAIL" v-model="call_tag.contact_option" /> EMAIL</label>
								<template v-if="user.company_id == 'hairplus'">
									<label class="mgr_10"><input type="radio" value="CUSTOMER KAKAO" v-model="call_tag.contact_option" /> CUSTOMER KAKAO</label>
									<label class="mgr_10"><input type="radio" value="SALES" v-model="call_tag.contact_option" /> SALES</label>
								</template>
								<template v-else>
									<label class="mgr_10"><input type="radio" value="PICK UP" v-model="call_tag.contact_option" /> PICK UP</label>
									<label class="mgr_10"><input type="radio" value="KAKAO TALK" v-model="call_tag.contact_option" /> KAKAO TALK</label>
								</template>
								<label class="mgr_10"><input type="radio" value="OTHER" v-model="call_tag.contact_option" /> OTHER</label>
								<input type="text" class="tbl_int mm_int" placeholder="" v-model.trim="call_tag.contact_option_other" :disabled="call_tag.contact_option != 'OTHER'" @focus="$event.target.select()" />
							</td>
						</tr>
						<tr>
							<th>Request Date</th>
							<td>
								<CustomDatePicker v-model="call_tag.request_date" />
							</td>
							<th>Entry</th>
							<td>{{ call_tag.crt_user }}</td>
						</tr>
						<tr>
							<th>Ship To</th>
							<td>
								<div style="float:left;"><PartnerSelect v-model="call_tag.ship_to_code" :initialName="call_tag.ship_to_name" ph="Ship To" @set-partner="setShipTo" /></div>
							</td>
							<th>Sales Person</th>
							<td><CodeSelect className="tbl_select" :codes="salesGroups" v-model="call_tag.sales_group_code" /></td>
						</tr>
						<tr>
							<th>Store Name</th>
							<td>
								<input type="text" v-model.trim="call_tag.store_name" class="tbl_int mm_int" />
							</td>
							<td rowspan="4" colspan="2" valign="top">
								<h4 class="inner_h5">Invoice(s) <input type="button" value="Add" class="gray_bt" @click="addInvoice()" style="margin-top:-3px;" /></h4>
								<table class="list_tbl">
									<thead>
										<tr>
											<th style="text-align:center;width:18%;">Inv No</th>
											<th style="text-align:center;width:18%;">S/O No</th>
											<th style="text-align:center;width:20%;">Inv Date</th>
											<th style="text-align:center;width:16%">Amount</th>
											<th style="text-align:center;width:16%">Ship To</th>
											<th style="text-align:center;width:10%">Del</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no">
											<td class="al_left">
												<!-- {{ invoice.invoice_dn }} -->
												<a href="javascript:;" @click="selectInvoice(invoice)">{{ invoice.invoice_dn }}</a>
											</td>
											<td class="al_left">
												<!-- {{ invoice.so_dn }} -->
												<a href="javascript:;" @click="selectSO(invoice)">{{ invoice.so_dn }}</a>
											</td>
											<td class="al_left">{{ invoice.invoice_date }}</td>
											<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
											<td class="al_left">{{ invoice.ship_to_code }}</td>
											<td><a href="javascript:;" type="button" class="gray_bt" @click="delInvoice(invoice)">Del</a></td>
										</tr>
									</tbody>
								</table>
							</td>
						</tr>
						<tr>
							<th>Address</th>
							<td>
								<input type="text" class="tbl_int quarter2_int" v-model.trim="call_tag.address_detail" />
							</td>
						</tr>
						<tr>
							<th>City, State & Zip</th>
							<td>
								<input type="text" class="tbl_int mm_int" placeholder="NEW YORK" v-model.trim="call_tag.address_city" />
								<input type="text" class="tbl_int sm_int" placeholder="NY" v-model.trim="call_tag.address_state" style="margin-left:5px;" />
								<input type="text" class="tbl_int ssm_int" placeholder="10029" v-model.trim="call_tag.address_zipcode" style="margin-left:5px;" />
							</td>
						</tr>
						<tr>
							<th>Phone No</th>
							<td>
								<input type="text" class="tbl_int mm_int" v-model.trim="call_tag.telephone" />
							</td>
						</tr>
						<tr>
							<td colspan="2" valign="top" style="padding-right:300px;">
								<h4 class="inner_h5">
									Weight(Box/LB) <input type="text" v-model="weights.length" class="tbl_int sss2m_int al_right" readonly disabled />
									<input type="text" v-model="weightSum" class="tbl_int sss2m_int al_right" readonly disabled />
									<input type="button" value="Add" class="gray_bt" @click="addWeight()" style="margin-top:-3px;" />
								</h4>
								<table class="list_tbl">
									<thead>
										<tr>
											<th style="text-align:center;width:25%;">Box No</th>
											<th style="text-align:center;width:50%;">Weight</th>
											<th style="text-align:center;width:25%;">Del</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(weight, index) in weights" v-bind:key="index">
											<td class="al_right">{{ index + 1 }}</td>
											<td class="al_right"><currency-input type="text" v-model.trim="weight.val" :precision="0" class="tbl_int ssssm_int al_right" @focus="$event.target.select()" /></td>
											<td><a href="javascript:;" type="button" class="gray_bt" @click="delWeight(index)">Del</a></td>
										</tr>
									</tbody>
								</table>
							</td>
							<td colspan="2" valign="top">
								<h4 class="inner_h5">Items <a href="javascript:;" class="search_bt mgl_15" style="margin-top:-5px;" @click="searchAndAddItems()">Search and Add Item(s)</a></h4>
								<textarea v-model.trim="call_tag.items" class="tbl_int" style="height: 200px;" />
							</td>
						</tr>
						<tr>
							<td colspan="2" valign="top" style="padding-right:200px;">
								<h4 class="inner_h5">
									Tracking No <input type="button" value="Add" class="gray_bt" @click="addTrackingNo()" style="margin-top:0px;" />
									<input type="text" ref="barcode_to_find" class="tbl_int" v-model.trim="barcode_to_find" placeholder="Barcode Scan" autocomplete="off" style="width:200px;" @keypress.enter="barcodeScan()" @focus="$event.target.select()" />
								</h4>
								<table class="list_tbl">
									<thead>
										<tr>
											<th style="text-align:center;width:20%;">No</th>
											<th style="text-align:center;width:40%;">Tracking No</th>
											<th style="text-align:center;width:20%;">UPS</th>
											<th style="text-align:center;width:15%;">Del</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(tracking_no, index) in tracking_nos" v-bind:key="index">
											<td class="al_right">{{ index + 1 }}</td>
											<td class="al_left"><input type="text" v-model.trim="tracking_no.val" class="tbl_int ssssm_int" @focus="$event.target.select()" /></td>
											<td class="al_center"><a :href="'https://ups.com/track?loc=null&tracknum=' + tracking_no.val + '&requester=WT/trackdetails'" target="_blank">Tracking</a></td>
											<td class="al_center"><a href="javascript:;" type="button" class="gray_bt" @click="delTrackingNo(index)">Del</a></td>
										</tr>
									</tbody>
								</table>
							</td>
							<td colspan="2" valign="top">
								<h4 class="inner_h5">Description</h4>
								<textarea v-model.trim="call_tag.description" class="tbl_int" style="height: 120px;" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="view_bottom_bt">
			<a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_5" @click="save(false)">Save & Return</a>
			<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="save(true)">Save Only</a>
			<a v-if="mode == 'detail'" href="javascript:void(0);" type="button" class="search_bt mgl_15" @click="CallTagPrint">Print</a>
			<a v-if="mode == 'detail' && call_tag.del_yn == 'N'" href="javascript:;" type="button" class="search_bt mgl_15" @click="makeOrViewSo">
				<template v-if="call_tag.linked_invoice_no">View</template><template v-else>Make</template> Return Sales Order
			</a>
			<a v-if="modifiable && mode == 'detail' && !call_tag.linked_invoice_no && call_tag.del_yn == 'N'" href="javascript:void(0);" type="button" class="search_bt mgl_15" @click="makeVoid">Void</a>
			<a v-if="modifiable && mode == 'detail' && call_tag.del_yn == 'Y'" href="javascript:void(0);" type="button" class="search_bt mgl_15" @click="revive">Revive</a>
			<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Cancel</a>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'invoice'" :draggable="false">
			<template slot="title">Select Invoice</template>
			<template slot="body">
				<SimpleInvoicePopup :initialShipToCode="call_tag.ship_to_code" v-on:close="closeModal" />
			</template>
		</Modal>

		<Modal @close="closeModalItems" v-if="showModal && modalName == 'item'" :draggable="false">
			<template slot="title">Items</template>
			<template slot="body">
				<div style="width:800px; height:600px;" v-on:keyup.esc="close()">
					<table class="list_tbl">
						<thead>
							<tr>
								<th width="15%">{{ headers.class }}</th>
								<th>Name</th>
								<th width="15%">Color</th>
								<th width="8%">Unit Price</th>
								<th width="8%">Inv. Qty</th>
								<th width="8%">Quantity</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in call_tag_items" v-bind:key="index">
								<td class="al_left">
									<template v-if="index == 0 || (index > 0 && item.class_code != call_tag_items[index - 1].class_code)">
										{{ item.class_code }}
									</template>
								</td>
								<td class="al_left">
									<template v-if="index == 0 || (index > 0 && item.class_code != call_tag_items[index - 1].class_code)">
										{{ item.class_name }}
									</template>
								</td>
								<td class="al_left">{{ item.color_code }}</td>
								<td class="al_right">{{ item.unit_price | toCurrency }}</td>
								<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
								<td class="al_right">
									<currency-input
										type="text"
										ref="quantity"
										v-model.trim="item.quantity"
										:precision="0"
										:valueRange="{
											min: 0,
											max: item.shipped_quantity,
										}"
										class="r_int long_type al_right"
										@focus="$event.target.select()"
										@keydown.ctrl.enter.prevent="applyAndClose()"
										@keydown.down.prevent="keyDown('quantity', index)"
										@keydown.up.prevent="keyUp('quantity', index)"
									/>
								</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="applyAndClose()" class="search_bt">Apply & Close</a>
						<a href="javascript:;" @click="closeModalItems()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
//import { apiSelectPartner } from '@/api/partner/index.js';
import { apiIndex, apiSelectCallTag, apiInsertCallTag, apiUpdateCallTag, apiVoidCallTag, apiReviveCallTag, apiSelectCallTagItemList } from '@/api/sales/calltag.js';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
// import ItemClassSelect from '@/components/common/ItemClassSelect';
import SimpleInvoicePopup from '@/components/common/SimpleInvoicePopup';
import Modal from '@/components/common/Modal';
import { today } from '@/utils/date.js';

import 'floatthead';
import { apiGetBase64ReportTemplate, Report, reportMrtUrl } from '@/api/util';

export default {
	props: ['headers'],
	data: function() {
		return {
			backUri: '/sales/call_tag',
			mode: 'add',

			call_tag: {},
			call_tag_items: [],
			invoices: [],
			weights: [],
			tracking_nos: [],

			salesGroups: [],

			showModal: false,
			modalName: '',

			barcode_to_find: null,
		};
	},
	computed: {
		weightSum() {
			//console.log(this.boxItems);
			//console.log(this.boxItems.filter(i => i.box_no == this.selectedBox.box_no));
			var sum = 0;
			this.weights.forEach(w => {
				sum += Number(w.val);
			});
			return sum;
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		PartnerSelect,
		CodeSelect,
		CustomDatePicker,
		SimpleInvoicePopup,
		Modal,
	},
	methods: {
		selectInvoice(invoice) {
			if (invoice.invoice_type != 'B' && invoice.invoice_type != 'A') {
				//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, 'herp_invoice');
			}
		},
		selectSO(invoice) {
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
			window.open(routeData.href, 'herp_so');
		},
		barcodeScan() {
			if (this.barcode_to_find) {
				this.tracking_nos.push({ val: this.barcode_to_find });
				this.barcode_to_find = null;
			}
		},
		async searchAndAddItems() {
			//console.log(this.invoices.map(i => i.invoice_no));
			if (this.invoices.length == 0) {
				this.$toast.error('Select Invoice first');
				return;
			}

			const { data } = await apiSelectCallTagItemList({
				call_tag_no: this.call_tag.call_tag_no,
				invoice_nos: this.invoices.map(i => i.invoice_no),
			});

			this.call_tag_items = data.callTagItemList;
			//console.log(data);
			this.modalName = 'item';
			this.showModal = true;
		},
		async applyAndClose() {
			var total = 0;
			this.call_tag.items = '';
			this.call_tag_items
				.filter(i => i.quantity > 0)
				.forEach(i => {
					//console.log(i);
					this.call_tag.items += i.class_name + ' - ' + i.color_code + ' $' + i.unit_price + ' * ' + i.quantity + '\n';
					total += i.unit_price * i.quantity;
				});

			this.call_tag.items += '\nTotal : $' + total;
			this.closeModalItems();
		},
		closeModalItems() {
			this.showModal = false;
		},
		keyDown(ref, index) {
			if (index < this.call_tag_items.length - 1) {
				this.$refs[ref][index + 1].$el.select();
				// if (this.$refs[ref][index + 1].$el.offsetParent.offsetTop + 2 * this.$refs[ref][index + 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
				// 	this.$refs.div_wrapper.scrollTop += this.$refs[ref][index + 1].$el.offsetParent.scrollHeight + 1;
				// }
			}
		},
		keyUp(ref, index) {
			if (index > 0) {
				this.$refs[ref][index - 1].$el.select();
				//this.$refs.div_wrapper.scrollTop = this.$refs[ref][index - 1].$el.offsetParent.offsetTop;
			}
		},
		async makeVoid() {
			var { data } = await apiVoidCallTag(this.call_tag);
			if (data.result) {
				this.$toast.success('Voided successfully');
				this.$router.push(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async revive() {
			var { data } = await apiReviveCallTag(this.call_tag);
			if (data.result) {
				this.$toast.success('Revived successfully');
				this.call_tag.del_yn = 'N';
				//this.$router.push(this.backUri);
			} else {
				this.$toast.error(data.msg);
			}
		},
		makeOrViewSo() {
			if (this.call_tag.linked_invoice_no) {
				this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: this.call_tag.linked_invoice_no } });
			} else {
				this.$router.push({ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, call_tag_no: this.call_tag.call_tag_no } });
			}
		},
		addInvoice() {
			this.modalName = 'invoice';
			this.showModal = true;
		},
		closeModal(invoice) {
			if (invoice) {
				//console.log(invoice);
				const idx = this.invoices.findIndex(function(i) {
					return i.invoice_no === invoice.invoice_no;
				});

				if (idx > -1) {
					this.$toast.error('Already Included');
				} else {
					this.invoices.push(invoice);
				}
			}
			this.showModal = false;
		},
		delInvoice(invoice) {
			const idx = this.invoices.findIndex(function(i) {
				return i.invoice_no === invoice.invoice_no;
			});
			this.invoices.splice(idx, 1);
		},
		addWeight() {
			var weight = { val: 10 };
			this.weights.push(weight);
		},
		delWeight(index) {
			this.weights.splice(index, 1);
		},
		addTrackingNo() {
			var tracking_no = { val: '' };
			this.tracking_nos.push(tracking_no);
		},
		delTrackingNo(index) {
			this.tracking_nos.splice(index, 1);
		},
		setShipTo(partner) {
			//console.log(partner);
			this.call_tag.sales_group_code = partner.sales_group_code;
			this.call_tag.sales_group_name = partner.sales_group_name;

			this.call_tag.store_name = partner.name;
			this.call_tag.address_detail = partner.address_detail;
			this.call_tag.address_city = partner.address_city;
			this.call_tag.address_state = partner.address_state;
			this.call_tag.address_zipcode = partner.address_zipcode;
			this.call_tag.telephone = partner.telephone;
		},
		async selectCallTag() {
			const { data } = await apiSelectCallTag({
				call_tag_no: this.call_tag.call_tag_no,
				for_call_tag: true,
			});
			//console.log(data);
			this.call_tag = data.call_tag;
			//console.log(this.call_tag);
			if (!['MAIL', 'EMAIL', 'PICK UP', 'KAKAO TALK', 'CUSTOMER KAKAO', 'SALES'].includes(this.call_tag.contact_option)) {
				this.call_tag.contact_option_other = this.call_tag.contact_option;
				this.call_tag.contact_option = 'OTHER';
			}
			//console.log(this.call_tag);
			var vm = this;

			vm.weights = [];
			if (data.call_tag.weights) {
				var weights = data.call_tag.weights.split('|');
				weights.forEach(w => {
					var weight = { val: Number(w) };
					vm.weights.push(weight);
				});
			}

			vm.tracking_nos = [];
			if (data.call_tag.tracking_nos) {
				var tracking_nos = data.call_tag.tracking_nos.split('|');
				tracking_nos.forEach(t => {
					var tracking_no = { val: t };
					vm.tracking_nos.push(tracking_no);
				});
			}

			this.invoices = data.invoiceList;
			//console.log(data.callTagItemList);
			this.call_tag_items = data.callTagItemList;
			//console.log(this.invoices);
		},
		async CallTagPrint() {
			const { data } = await apiSelectCallTag({
				call_tag_no: this.call_tag.call_tag_no,
			});
			let weights = [];
			let weightString = '';
			let totalLib = 0;
			if (data.call_tag.weights) {
				weights = data.call_tag.weights.split('|');
				weights.forEach(function(value, index) {
					if (index !== 0) {
						weightString += ', ';
					}
					totalLib += Number(value);
					weightString += '#' + (index + 1) + ' - ' + value;
				});
			}
			data.weightsLib = totalLib;
			data.weightsSize = weights.length;

			data.weightString = weightString;
			let tracking_nos = [];
			let trackingString = '';
			if (data.call_tag.tracking_nos) {
				tracking_nos = data.call_tag.tracking_nos.split('|');
				trackingString = tracking_nos.join(', ');
			}

			data.trackingString = trackingString;
			let invoiceString = '';
			data.invoiceList.forEach(function(invoice, index) {
				if (index !== 0) {
					invoiceString += ', ';
				}
				invoiceString += invoice.invoice_dn;
			});
			data.invoiceString = invoiceString;
			const reportTemplate = await apiGetBase64ReportTemplate('CallTag', reportMrtUrl('CallTag'));
			const report = new Report(reportTemplate, data, 'CallTag');
			this.$store.commit('setReport', report);
		},
		checkValidity() {
			if (!this.call_tag.request_date) {
				this.$toast.error('Empty Request Date');
				return false;
			}

			if (!this.call_tag.ship_to_code) {
				this.$toast.error('Empty Ship To Code');
				return false;
			}
			return true;
		},

		async save(stay) {
			if (this.checkValidity()) {
				await this.submit(stay);
			}
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		async submit(stay) {
			//this.$toast.warning('To Be Developed.');
			//console.log(stay);
			var invoice_nos = [];
			if (this.invoices) {
				this.invoices.forEach(invoice => {
					invoice_nos.push(invoice.invoice_no);
				});
			}

			var weight_vals = [];
			this.weights.forEach(weight => {
				weight_vals.push(weight.val);
			});

			var tracking_no_vals = [];
			this.tracking_nos.forEach(tracking_no => {
				tracking_no_vals.push(tracking_no.val);
			});

			//this.call_tag.invoices = this.invoices;
			this.call_tag.invoice_nos = invoice_nos.join('|');
			this.call_tag.weights = weight_vals.join('|');
			this.call_tag.tracking_nos = tracking_no_vals.join('|');
			//console.log(this.call_tag_items);
			this.call_tag.item_list = this.call_tag_items.filter(i => i.quantity > 0);
			//console.log(this.call_tag);

			if (this.call_tag.contact_option == 'OTHER') this.call_tag.contact_option = this.call_tag.contact_option_other;

			var response;
			if (this.mode == 'add') {
				response = await apiInsertCallTag(this.call_tag);
			} else {
				response = await apiUpdateCallTag(this.call_tag);
			}
			var data = response.data;
			if (data.result) {
				this.$toast.success('Saved successfully');
				if (!stay) {
					this.$router.push(this.backUri);
				} else {
					if (this.mode == 'add') {
						this.call_tag.call_tag_no = data.call_tag_no;
						//this.invoice.so_dn = data.so_dn;
						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Call Tag -> Detail');
						await this.selectCallTag();
					}
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		async index() {
			const { data } = await apiIndex();

			// this.paymentTerms = data.paymentTermList;
			// this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			// this.deliveryTypes = data.deliveryTypeList;
			// this.remarks = data.remarkList;
			// this.specialSales = data.specialSaleList;
		},
		async init() {
			await this.index();

			if (this.mode == 'detail') {
				await this.selectCallTag();
				//console.log(getPossibleStatus(this.invoice.status_code));
				//this.saleStatusCodes = getPossibleStatus(this.invoice.status_code);
			}
			inputSelectOnClick();
		},
		// async test() {
		// 	const { data } = await apiInsertInvoice(this.invoice);

		// 	if (data.result) {
		// 		this.$toast.success('Saved successfully');
		// 	} else {
		// 		this.$toast.error(data.msg);
		// 	}
		// },
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_call_tag');
		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Call Tag -> Add');
			this.call_tag.request_date = today();
			var current_user = this.$session.get('user');
			this.call_tag.crt_user = current_user.user_id;
		} else {
			this.$store.commit('setSubTitle', 'Call Tag -> Detail');
			this.call_tag.call_tag_no = this.$route.query.call_tag_no;

			if (!this.call_tag.call_tag_no) {
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
		//console.log(this.backUri);

		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		inputSelectOnClick();
		$(this.$refs.invoice_items).floatThead({ zIndex: 1, autoReflow: true });
	},
};
</script>

<style></style>
